export const BrowserStorageKey = {
  IsAuthenticated: 'isAuthenticated',
  IsAuthRedirectInProgress: 'isAuthRedirectInProgress',
} as const;
